import StoryblokEditable from "components/StoryblokEditable"

export default function StoryblokVisualEditor({ story, children }) {
  if (!story?._editable) {
    return children
  }

  return <StoryblokEditable content={story}>{children}</StoryblokEditable>
}
